var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.25C7.44365 4.25 3.75 7.94365 3.75 12.5C3.75 13.5619 3.95027 14.5753 4.31442 15.5057C4.50304 15.9876 4.596 16.5392 4.50106 17.103L3.91458 20.5854L7.39704 19.9989C7.96081 19.904 8.51241 19.997 8.99431 20.1856C9.92468 20.5497 10.9381 20.75 12 20.75C16.5563 20.75 20.25 17.0563 20.25 12.5C20.25 7.94365 16.5563 4.25 12 4.25ZM2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C10.748 22.25 9.54935 22.0136 8.44759 21.5824C8.16576 21.4721 7.89114 21.4369 7.64615 21.4781L3.81731 22.1229C2.96976 22.2657 2.23435 21.5302 2.37708 20.6827L3.02189 16.8539C3.06315 16.6089 3.02791 16.3342 2.9176 16.0524C2.48637 14.9507 2.25 13.752 2.25 12.5Z",
    fill: "#542F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 10.4998C7.25 10.0855 7.58579 9.74976 8 9.74976H16C16.4142 9.74976 16.75 10.0855 16.75 10.4998C16.75 10.914 16.4142 11.2498 16 11.2498H8C7.58579 11.2498 7.25 10.914 7.25 10.4998ZM7.25 14.4998C7.25 14.0855 7.58579 13.7498 8 13.7498H12C12.4142 13.7498 12.75 14.0855 12.75 14.4998C12.75 14.914 12.4142 15.2498 12 15.2498H8C7.58579 15.2498 7.25 14.914 7.25 14.4998Z",
    fill: "#542F1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speechBubble.805d7ebdf4ea75cb2dea884c9244c69d.svg";
export { ForwardRef as ReactComponent };